export const SessionTimeoutConfig = {
  SESSION_COUNTDOWN_START: 3600,
  AUTO_LOGOUT_WAIT: 10,
};

export default SessionTimeoutConfig;
